import { ClientRepo } from "../../../clients/client.repo";

class ModifyDietzDialogController {
  public client: any;
  public isLoading: boolean;

  /** @ngInject */
  constructor(
    private $mdDialog: angular.material.IDialogService,
    private clientRepo: ClientRepo,
    private notifyjs
  ) {}
  
  save() {
    this.isLoading = true
    this.clientRepo.modifyDietz(this.client.id, this.client.dietz)
        .catch(exc => {
            console.log(exc)
        })
        .finally(() => {
            this.$mdDialog.hide(true);
            this.isLoading = false;
        })
  }

  cancel() {
    this.$mdDialog.hide();
  }
}

export const modifyDietzDialog: angular.IComponentOptions = {
  template: require("./modify-dietz.dialog.html"),
  controller: ModifyDietzDialogController,
  bindings: {
    client: "<",
  },
};



// WEBPACK FOOTER //
// ./src/app/portfolioadmin/attribution/modify-dietz-dialog/modify-dietz.dialog.ts